var path = 'src/app/components/common/pawn-tag-select/pawn-tag-select.template.html';
var html = "<select\n  required\n  ng-disabled=\"!$ctrl.manualSelection\"\n  ng-model=\"$ctrl.pawn.tagId\"\n  ng-options=\"t.id as t.name for t in $ctrl.tags\">\n</select>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;